<template>
  <Navbar/>
  <router-view v-slot="{ Component }">
    <keep-alive include="HomeView">
      <component :is="Component" />
    </keep-alive>
  </router-view>
  <FooterSection />
</template>

<script>
import Navbar from '@/components/global/NavBar.vue'
import FooterSection from '@/components/global/FooterSection.vue'
export default {
  name: 'App',
  components: {
    Navbar,
    FooterSection,
  }
}
</script>
